<template>
  <div class="whole store-add">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <el-form ref="form" label-width="80px" class="content">
        <el-form-item label="技师ID">
          <el-input style="width: 300px" v-model="product.id"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input style="width: 300px" v-model="product.userName"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input style="width: 300px" v-model="product.phone"></el-input>
        </el-form-item>
        <el-form-item label="技师分类">
          <el-cascader
            style="width: 300px"
            v-model="categorySelect"
            :options="categoryOptions"
            @change="onCategoryChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="个人比例">
          <el-input
            style="width: 300px"
            v-model="product.scale"
            placeholder="请输入个人分成比例(0~1)"
          ></el-input>
        </el-form-item>
        <el-form-item label="地图">
          <el-amap-search-box
            :search-option="searchOption"
            :on-search-result="onSearchResult"
          ></el-amap-search-box>

          <el-amap
            class="amap-box"
            :vid="'amap-vue'"
            :events="events"
            :center="center"
            :plugin="plugin"
          >
            <el-amap-marker :position="center" />
          </el-amap>

        </el-form-item>
        <el-form-item label="地址">
          <el-input
            type="textarea"
            v-model="product.detailed"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="个人简介">
          <el-input
            type="textarea"
            v-model="product.intro"
            placeholder="请输入个人简介"
          ></el-input>
        </el-form-item>
        <el-form-item label="技师图片">
          <el-upload
            action=""
            class="upload-demo"
            :http-request="uploadSectionFile"
            :limit="1"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-button type="primary" @click="onSubmit" class="btn-submit"
          >提交</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getAllProvince,
  getAllTechnicianCategory,
  addTechnician,
  uploadFile1
} from "api/request";
import { ERR_OK } from "api/config";
import { loadingInstance, Error } from "common/js/util";
import { Success } from "../../common/js/util";
var Geocoder = null;
var center = [106.744611, 26.664717];
export default {
  components: {
    MSidebar,
    MHeader
  },
  data() {
    return {
      product: {
        photo: null,
        intro: null,
        id: null,
        userName: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        streetCode: null,
        phone: null,
        detailed: null,
        categoryId: null,
        province: null,
        city: null,
        county: null,
        street: null,
        lng: 0,
        lat: 0
      },
      fileList: [],
      categorySelect: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      streetList: [],
      categoryOptions: [],
      center: [106.744611, 26.664717],
      searchOption: {
        city: "贵阳",
        citylimit: false
      },
      events: {
        init: o => {
          o.getCity(result => {
            console.log("事件初始化");
            console.log(result);
          });
        },
        click: e => {
          console.log(e);
          var center = [];
          center.push(e.lnglat.lng);
          center.push(e.lnglat.lat);
          this.center = center;
          var that = this;
          Geocoder.getAddress(center, function(status, result) {
            if (status === "complete" && result.info === "OK") {
              var adcode = result.regeocode.addressComponent.adcode;
              var provinceCode = adcode.slice(0, 2) + "0000";
              var cityCode = adcode.slice(0, 4) + "00";
              var countyCode = adcode;
              that.product.provinceCode = provinceCode;
              that.product.province =
                result.regeocode.addressComponent.province;
              that.product.cityCode = cityCode;
              that.product.city = result.regeocode.addressComponent.city;
              that.product.countyCode = countyCode;
              that.product.county = result.regeocode.addressComponent.district;
              that.product.detailed = result.regeocode.formattedAddress;
              that.product.lng = e.lnglat.lng;
              that.product.lat = e.lnglat.lat;
            }
          });
        }
      },
      plugin: [
        {
          pName: "Geocoder",
          events: {
            init(o) {
              Geocoder = o;
              o.getAddress(center, function(status, result) {
                if (status === "complete" && result.info === "OK") {
                  console.log("初始化插件");
                  console.log(result);
                }
              });
            }
          }
        },
        {
          showMarker: true,
          pName: "Geolocation",
          events: {
            init(o) {
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  var center = [];
                  center.push(result.position.lng);
                  center.push(result.position.lat);
                  this.center = center;
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this._getProvinceList("0");
      this._getCategoryList();
    }
  },
  methods: {
    onSearchResult(e) {
      console.log("搜索返回");
      console.log(e);
      var center = [];
      center.push(e[0].lng);
      center.push(e[0].lat);
      this.center = center;
      var that = this;
      Geocoder.getAddress(center, function(status, result) {
        if (status === "complete" && result.info === "OK") {
          var adcode = result.regeocode.addressComponent.adcode;
          var provinceCode = adcode.slice(0, 2) + "0000";
          var cityCode = adcode.slice(0, 4) + "00";
          var countyCode = adcode;
          that.product.provinceCode = provinceCode;
          that.product.province = result.regeocode.addressComponent.province;
          that.product.cityCode = cityCode;
          that.product.city = result.regeocode.addressComponent.city;
          that.product.countyCode = countyCode;
          that.product.county = result.regeocode.addressComponent.district;
          that.product.detailed = result.regeocode.formattedAddress;
          that.product.streetCode = result.regeocode.addressComponent.towncode;
          that.product.street = result.regeocode.addressComponent.township;
          that.product.detailed = result.regeocode.formattedAddress;
          that.product.lng = e[0].lng;
          that.product.lat = e[0].lat;
        }
      });
    },
    onCategoryChange(v) {
      this.categorySelect = v;
      this.product.categoryId = v[1];
    },
    onSubmit() {
      addTechnician(this.product).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          Success(this, res);
          // 跳转到列表页面
        } else {
          Error(this, res);
        }
      });
    },
    _getProvinceList(code) {
      loadingInstance(Loading);
      getAllProvince({
        pcode: code
      }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.provinceList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getCityList(code) {
      loadingInstance(Loading);
      getAllProvince({
        pcode: code
      }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.cityList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getCountyList(code) {
      loadingInstance(Loading);
      getAllProvince({
        pcode: code
      }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.countyList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getStreetList(code) {
      loadingInstance(Loading);
      getAllProvince({
        pcode: code
      }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.streetList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getCategoryList() {
      loadingInstance(Loading);
      getAllTechnicianCategory().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.categoryOptions = res.data.records.map(item => {
            return {
              value: item.id,
              label: item.name,
              children: item.umTechnicianCategoryVos.map(s => {
                return {
                  value: s.id,
                  label: s.name
                };
              })
            };
          });
        } else {
          Error(this, res);
        }
      });
    },
    //文件类型   101 商品图片 102 供应商营业执照  103 banner图    104商品分类logo
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 104);
      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.product.photo = res.data;
        } else {
          Error(this, res);
        }
      });
    }
  }
};
</script>

<style scoped>
.store-add .content {
  padding: 20px;
}

.store-add .content .btn-submit {
  margin: 0 auto;
  display: block;
}
.amap-box {
  height: 500px;
  width: 500px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #0e0e0e;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/teache/teacherAdd.vue